import type { FC, ReactNode } from 'react';
import { Fragment } from 'react';

import type { EnquiriesStoreState } from 'Features/SellerCommunications/services';

import { ModalEnquiryListContainer } from './ModalEnquiryListContainer';
import { ModalEnquiryListItems } from './ModalEnquiryListItems';

import styles from './ModalEnquiryList.module.scss';

export interface ModalEnquiryListGroupsProps {
	groups: {
		enquiries: EnquiriesStoreState['enquiries'];
		title: ReactNode;
	}[];
}

export const ModalEnquiryListGroups: FC<ModalEnquiryListGroupsProps> = ({ groups }) => (
	<ModalEnquiryListContainer>
		{groups.map(({ enquiries, title }) =>
			enquiries.length ? (
				<Fragment key={`${title}`}>
					<div className={styles.failedSalesTextContainer}>
						<h5 className={styles.failedSalesHeading}>{title}</h5>
						<span className={styles.failedSalesCount} data-testid="seller-comms-enquiries-count">
							{enquiries.length}
						</span>
					</div>
					<ModalEnquiryListItems enquiries={enquiries} />
				</Fragment>
			) : null,
		)}
	</ModalEnquiryListContainer>
);
